/**
 * Modos de edición de la pantalla de edición de la tarifa
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
enum RateDetailMode {
    None = 'none',
    Editing = 'editing',
    Creating = 'creating',
}

export default RateDetailMode
